/**
 * Rodapé mínimo (apenas faixa de copyright/CNPJ) — usado em todas as páginas
 * que NÃO são institucionais (LPs de captura, LPs de venda, aulas
 * experimentais, quizzes, cbfeo, etc.). O cabeçalho/rodapé institucionais
 * completos só aparecem em `/`, `/quem-somos` e `/politica-de-privacidade`.
 *
 * `variant="light"` é a versão para páginas de fundo claro (ex.: /feoclinicas-2).
 */
export function MinimalFooter({
  className = "",
  variant = "dark",
}: {
  className?: string;
  variant?: "dark" | "light";
}) {
  const theme =
    variant === "light"
      ? "border-fcl-line bg-fcl-surface text-fcl-muted"
      : "border-white/10 bg-deep text-white/70";

  return (
    <footer
      className={`w-full border-t py-6 text-center text-[10px] sm:text-xs ${theme} ${className}`}
    >
      <div className="container mx-auto px-4 sm:px-6">
        Todos os direitos reservados.&nbsp;Fisio em Ortopedia&nbsp;© 2026
      </div>
    </footer>
  );
}
